<template>
    <q-modal
        :value="opened"
        @hide="close"
    >
        <div class="q-pa-lg payment-errors-modal">
            <div class="row items-center justify-between q-mb-lg">
                <div class="row items-center">
                    <q-icon name="error_outline" size="26px" class="q-mr-sm"/>
                    <div class="text-h6">
                        Ошибки оплат по счёту № {{ bill.number }}
                    </div>
                </div>
            </div>
            <table class="full-width">
                <thead>
                    <tr>
                        <th class="text-left q-pa-sm">Попытка</th>
                        <th class="text-left q-pa-sm text-no-wrap">Дата</th>
                        <th class="text-left q-pa-sm text-no-wrap">ID платежа</th>
                        <th class="text-left q-pa-sm text-no-wrap">Номер карты</th>
                        <th class="text-left q-pa-sm text-no-wrap">Способ оплаты</th>
                        <th class="text-left q-pa-sm text-no-wrap">Код ошибки</th>
                        <th class="text-left q-pa-sm text-no-wrap">Описание ошибки</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(attempt, index) in attemptsWithError"
                        :key="index"
                    >
                        <td class="q-pa-sm">{{ index + 1 }}</td>
                        <td class="q-pa-sm">{{ attempt.createdAt }}</td>
                        <td class="q-pa-sm">{{ attempt.paymentId }}</td>
                        <td class="q-pa-sm">{{ attempt.cardPan }}</td>
                        <td class="q-pa-sm">{{ attempt.paymentMethod }}</td>
                        <td class="q-pa-sm">{{ attempt.code }}</td>
                        <td class="q-pa-sm">{{ attempt.description }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="row justify-end q-mt-md">
                <q-btn
                    flat
                    color="primary"
                    label="Закрыть"
                    @click="close"
                />
            </div>
        </div>
    </q-modal>
</template>

<script>

import api from 'mixins/api'
import { date, QModal, QBtn, QIcon } from 'quasar'

export default {
    name: 'PaymentErrorsModal',

    components: {
        QModal,
        QBtn,
        QIcon,
    },

    mixins: [api],

    props: {
        opened: {
            type    : Boolean,
            required: true,
        },
        bill: {
            type    : Object,
            required: true,
        },
    },

    data () {
        return {
            paymentMethods: [],
        }
    },

    mounted () {
        this.fetchProjectPaymentMethods()
    },

    computed: {
        paymentMethodsMap () {
            const map = {};

            this.paymentMethods.forEach(method => {
                if (method && method.method) {
                    map[method.method] = method.card_pan;
                }
            })

            return map;
        },

        liqpayErrors () {
            return Array.isArray(this.bill.liqpay_errors) ? this.bill.liqpay_errors : [];
        },

        stripeErrors () {
            return Array.isArray(this.bill.stripe_errors) ? this.bill.stripe_errors : [];
        },

        attemptsWithError () {
            const liqpay = this.liqpayErrors.map(error => ({
                paymentMethod: 'LiqPay',
                paymentId    : error.payment_id,
                createdAt    : this.formatDate(error.created_at),
                code         : error.code,
                description  : error.description,
                cardPan      : this.paymentMethodsMap.liqpay || ''
            }));

            const stripe = this.stripeErrors.map(error => ({
                paymentMethod: 'Stripe',
                paymentId    : error.payment_id,
                createdAt    : error.created_at,
                code         : error.code,
                description  : error.description,
                cardPan      : this.paymentMethodsMap.stripe || ''
            }));

            return [...liqpay, ...stripe];
        },
    },

    methods: {
        fetchProjectPaymentMethods () {
            this.api.get(`/projects/${ this.bill.project_id }/payment-method-type`)
                .then(response => {
                    this.paymentMethods = response.data
                })
                .catch(() => {
                    this.paymentMethods = []
                });
        },

        formatDate (value) {
            return date.formatDate(value, 'DD.MM.YYYY, HH:mm:ss ')
        },

        close() {
            this.$emit('closed');
        },
    },
}
</script>

<style scoped>
th {
    border-bottom: 1px solid #e0e0e0;
    font-weight: 600;
}

td {
    border-bottom: 1px solid #f0f0f0;
}

.payment-errors-modal {
    display: inline-block;
    max-width: 90vw;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/BillsList/PaymentErrorsModal.vue